import useResizeObserver from '@react-hook/resize-observer';
import { useLayoutEffect, useRef, useState } from 'react';

const useSize = target => {
	const [size, setSize] = useState();

	useLayoutEffect(() => {
		if (target.current) setSize(target.current.getBoundingClientRect());
	}, [target]);

	// Where the magic happens
	useResizeObserver(target, entry => setSize(entry.contentRect));
	return size;
};

const calculateLayerSizePosStyle = (imgSize, containerSize, zoomLevel) => {
	let left = 0;
	let width = 0;
	let height = 0;
	if (containerSize && containerSize.width && containerSize.height && imgSize.width && imgSize.height) {
		if (zoomLevel > 0) {
			width = imgSize.width * zoomLevel;
			height = imgSize.height * zoomLevel;
			left = (containerSize.width - width) / 2;
		} else {
			const aspectRatio = imgSize.width > imgSize.height ? imgSize.width / imgSize.height : imgSize.height / imgSize.width;
			width = containerSize.width;
			height = containerSize.width * aspectRatio;
		}
	}
	return { width: `${width}px`, height: `${height}px`, left: `${left}px` };
};

const calculateLayerSize = (imgSize, containerSize, zoomLevel) => {
	let width = 0;
	let height = 0;
	if (containerSize && containerSize.width && containerSize.height && imgSize.width && imgSize.height) {
		if (zoomLevel > 0) {
			width = imgSize.width * zoomLevel;
			height = imgSize.height * zoomLevel;
		} else {
			const aspectRatio = imgSize.width > imgSize.height ? imgSize.width / imgSize.height : imgSize.height / imgSize.width;
			width = containerSize.width;
			height = containerSize.width * aspectRatio;
		}
	}
	return { width, height };
};

function ExamImage(props) {
	const { imgUrl, imgKey, imgSize, zoomLevel, LayerComponent, onChange } = props;
	const containerRef = useRef(null);
	const imgRef = useRef(null);
	const containerSize = useSize(containerRef);

	return (
		<div ref={containerRef} className="w-full bg-gray-600 flex justify-center oveflow-x-scroll relative">
			<img ref={imgRef} src={imgUrl} alt={imgKey} width={zoomLevel > 0 ? `${imgSize.width * zoomLevel}px` : '100%'} />
			<div className="absolute left-0 top-0" style={calculateLayerSizePosStyle(imgSize, containerSize, zoomLevel)}>
				{LayerComponent && <LayerComponent onChange={onChange} originalSize={{ width: imgSize.width, height: imgSize.height }} size={calculateLayerSize(imgSize, containerSize, zoomLevel)} />}
			</div>
		</div>
	);
}

export default ExamImage;
